import React from "react";
import { Banner, Card, FormLayout, Modal, TextContainer } from "@shopify/polaris";
import { CsI18n } from "../../shared/csI18n/csI18n";
import { GenerationEnvSwitcher } from "./GenerationActions";

const Production = props => {
  const { prodContent, prodStyle } = props;

  return <div id='cs-preview' className={'ck-content'}
              dangerouslySetInnerHTML={{ __html: prodContent + `<style>${prodStyle}</style>` }} />;
};

class GenerationTabContentProduction extends React.Component {
  render() {
    const {
      pageId, pageType, handleChangeEnv,
      prodContent, prodStyle, token,
      showPublishedNotice, handleDismissPublishedNotice,
      publishing, handlePublishPageConfirm, handlePublishPage,
      modalPublishConfirm, handleToggleModalPublish,
    } = this.props;
    const switcher =
      <GenerationEnvSwitcher
        isProd={true} pageType={pageType} handleChangeEnv={handleChangeEnv}
        pageId={pageId} prodContent={prodContent} publishing={publishing} token={token}
        handlePublishPageConfirm={handlePublishPageConfirm}
      />

    return (
      <>
        <Card.Section sectioned>
          <FormLayout>
            {switcher}
            {showPublishedNotice &&
            <div>
              <Banner status="success" onDismiss={handleDismissPublishedNotice}>
                <CsI18n>The changes have been saved and published on the site, it is possible that the changes will be
                  updated with a certain delay.</CsI18n>
              </Banner>
            </div>}
          </FormLayout>
        </Card.Section>

        <Card.Section>
          <Production prodContent={prodContent} prodStyle={prodStyle} />
        </Card.Section>

        <Card.Section>{switcher}</Card.Section>

        <Modal
          open={modalPublishConfirm}
          title={CsI18n.t('Publish page')}
          onClose={handleToggleModalPublish}
          primaryAction={{ content: CsI18n.t('Publish'), onAction: handlePublishPage }}
          secondaryActions={[{ content: CsI18n.t('Cancel'), onAction: handleToggleModalPublish }]}
        >
          <Modal.Section>
            <TextContainer>
              <p><CsI18n>I take the entire responsibility on the changes has been made on the document.</CsI18n></p>
            </TextContainer>
          </Modal.Section>
        </Modal>
      </>
    )
  }
}

export default GenerationTabContentProduction;
